import Vue from 'vue';

export function errorAlert(vm, message) {
    return vm.$bvModal.msgBoxOk(message, {
        title: 'Erreur',
        size: 'sm',
        buttonSize: 'sm',
        headerClass: 'p-2 border-bottom-0 bg-danger',
        footerClass: 'p-2 border-top-0',
        centered: true
    });
}